import { Api, LocalDictionaryFactory } from './../api/api.module'
import { ColumnModel } from '../api/api.models'

import { ScopeBaseGridsterGrid } from '../common/common.base.grid.gridster.controller'
import { GridTypes, GridButtonsOptions, GridController, GridCustomButtonsOptions, GridCustomButtonLocation } from '../common/grid'

import { CommonHelper, EventsNames, LocalizationHelper, TemplateHelper, ConfigHelper } from '../../helpers/'

import { Activity, Enums } from '../../models/common/'
import { OpPackage } from '../../models/core'

import { PackageService } from '../../services/package'
import { PackagesHelper } from './packages.helper'
import { SystemService } from '../../services/system'
import { UserSessionService } from '../../services/user-session'

import { BaseGridController } from '../common/common.base.grid.controller'
import { CreateEditInitParams } from '../common/create-edit-popup/create-edit-popup.controller'
import { ISearchBySerialNbr, SearchBySerialNbrOpitons } from '../orders/components/search-by-serial-nbr/order-search-by-serial-nbr.interfaces'
import { StateService } from '@uirouter/angularjs'

export class PackageController extends BaseGridController {

    //#region Costs

    private get PACKAGES_GRID_NAME(): string { return 'PACKAGES_GRID' }

    //#endregion


    // #region Members

    public deleteConfirmationOptions: {
        title: string
        onConfirmed: () => void
    }

    private grid: GridController<OpPackage>

    private searchOptions: SearchBySerialNbrOpitons
    private searchBySerialNbr: ISearchBySerialNbr

    // #endregion


    constructor(
        protected $scope: ScopeBaseGridsterGrid,
        $state: StateService,
        $timeout: ng.ITimeoutService,
        api: Api,
        localDictionary: LocalDictionaryFactory,
        private packageService: PackageService,
        protected systemService: SystemService,
        protected userSessionService: UserSessionService,
        referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super($scope, $timeout, $state, userSessionService, systemService, api, localDictionary, null, referenceType)

        this.initializeConfirmations()
        this.initializeSearchByNbr()
        this.setEvents()
        this.setMainGridOptions()
    }


    // #region Events

    private onInitialized(e: any, grid: GridController<OpPackage>): void {
        this.dataGrid = e.component
        this.grid = grid

        this.setGridId(e.tableId)
    }

    private onAdd(): void {
        this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, PackagesHelper.getCreateEditOptions(this.userSessionService))
    }

    private onConfirmDelete(): void {
        this.packageService
            .deletePackage(this.grid.selectedItem)
            .then(() => {
                this.$scope.$root.$broadcast(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName))
            })
    }

    private onDelete(): void {
        this.$scope.$broadcast(
            EventsNames.OPEN_CONFIRMATION_POPUP + this.$scope.popupId,
            LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__CONFIRM_DELETE, this.moduleName)
        )
    }

    private onDeleted(): void {
        this.dataGrid.refresh()
    }

    private onEdit(): void {
        if (this.dataGrid.getSelectedRowKeys().length == 1) {
            const createEditInitParams: CreateEditInitParams = PackagesHelper.getCreateEditOptions(this.userSessionService, this.grid.selectedItemId)

            this.$scope.$broadcast(EventsNames.INITIALIZE_CREATE_EDIT_POPUP, createEditInitParams)
        } else {
            // const columnCount: number = this.dataGrid.columnCount()
            // const columns: any[] = []

            // for (let i = 0; i < columnCount; i++) {
            //     columns.push(this.dataGrid.columnOption(i));
            // }

            // const bulkEditInitParams: BulkEditInitParams = {
            //     gridColumns: columns,
            //     groupReferenceType: null,
            //     groupReferenceValue: null,
            //     idReferenceType: this.referenceType,
            //     moduleName: this.moduleName,
            //     section: null,
            //     selectedGridRows: angular.copy(this.grid.selectedGridItems),
            //     useBusinessObjects: true
            // }
            // // Potrzebne do odczytania CREATION_DATE z OpIssue dla masowej edycji.
            // bulkEditInitParams['__issues_bulk_edit_data__'] = this.grid.selectedItems

            // this.$scope.$root.$broadcast(EventsNames.INITIALIZE_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    private onShowDetails(e: any): void {
        this.systemService.openDetails({
            moduleName: this.moduleName,
            referenceObjectId: this.grid.selectedItemId,
            pageItemsIds: this.grid.pageItemsIds,
        })
    }

    // #endregion


    // #region Setup

    private getContextMenuItems(isTouchScreen: boolean = false): any[] {
        const items = []

        if (this.userSessionService.getLoggedOperator().hasPermission(Activity.ORDER_EDIT)) {
            items.push({
                beginGroup: true,
                template: TemplateHelper.getContextMenuItem(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Edit), ConfigHelper.Icon.EDIT, this.userSessionService),

                onItemClick: (e: any) => this.onEdit(),
            })
        }

        return this.mergeWithDefaultItems(isTouchScreen, items)
    }


    private getGridButtonsOptions(): GridButtonsOptions {
        return {
            enabled: true,

            addPermissions: this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_ADD) ? "['" + Activity[Activity.PACKAGE_ADD] + "']" : null,
            deletePermissions: this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_DEL) ? "['" + Activity[Activity.PACKAGE_DEL] + "']" : null,
            editPermissions: this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_EDIT) ? "['" + Activity[Activity.PACKAGE_EDIT] + "']" : null,
            saveColumnSettingsPermissions: this.userSessionService.getLoggedOperator().hasPermission(Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP) ? "['" + Activity[Activity.WEBSIMAX_MODULE_VIEW_COLUMN_DEFINITION_OP] + "']" : null,
            showDetailsPermissions: this.userSessionService.getLoggedOperator().hasPermission(Activity.PACKAGE_LIST) ? "['" + Activity[Activity.PACKAGE_LIST] + "']" : null,

            onAddClick: () => this.onAdd(),
            onDeleteClick: () => this.onDelete(),
            onEditClick: () => this.onEdit(),
            onShowClick: (e: any) => this.onShowDetails(e)
        }
    }

    private getGridCustomButtonsOptions(): GridCustomButtonsOptions {
        return {
            buttons: [{
                location: GridCustomButtonLocation.Dropdown,
                options: {
                    template: TemplateHelper.getIcon(ConfigHelper.Icon.DETAILS, this.userSession),
                    hint: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FindPackageBySerialNbr),

                    onClick: (e: any) => {
                        this.showSearchBySerialNumber()
                    },
                }
            }]
        }
    }

    private initializeConfirmations(): void {
        this.deleteConfirmationOptions = {
            title: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__DELETING, this.moduleName),

            onConfirmed: () => this.onConfirmDelete()
        }
    }

    private setEvents() {
        this.$scope.$on(EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__DELETED, this.moduleName), (event: ng.IAngularEvent, ...args: any[]) => this.onDeleted())
        this.$scope.showDetails = (e: any) => this.onShowDetails(e)

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__REFRESH, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => { this.grid.dxGrid.refresh() }
        )
    }

    private setMainGridOptions() {
        this.packageService
            .getMainGridColumns()
            .then((columns: ColumnModel[], defaultColumns: ColumnModel[]) => {
                this.$scope.mainGridOptions = {
                    addCustomFilters: true,
                    buttonsOptions: this.getGridButtonsOptions(),
                    customButtonOptions: this.getGridCustomButtonsOptions(),
                    columnsDictionary: columns,
                    defaultColumnsDictionary: defaultColumns,
                    getDataSourceMethod: this.userSessionService.getDataProvider().Package.getPackageFilter,
                    idReferenceType: this.referenceType,
                    referenceId: this.referenceType,
                    localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.packageSaved,
                    name: this.PACKAGES_GRID_NAME,
                    preExecuteClearFilter: this.preExecuteGridClearFilter,
                    type: GridTypes.MAIN,

                    allowColumnReordering: !this.userSessionService
                        .getLoggedOperator()
                        .hasPermission(Activity.WEBSIMAX_COLUMN_REORDER_DISALLOWED, Enums.UIObjectProperties.PackageModuleMainGrid),

                    contextMenuItems: (isTouchScreen: boolean = false) => this.getContextMenuItems(isTouchScreen),
                    onDataReady: (data: any) => this.onDataReady(data),
                    onInitialized: (e: any, grid: GridController<OpPackage>) => this.onInitialized(e, grid),
                    onRowDoubleClick: (e: any) => this.onShowDetails(e),
                }
            })
    }

    // #endregion

    // #region Search By Serial Number 

    private initializeSearchByNbr(): void {
        this.searchOptions = {
            onFoundPackage: (packageIds: number[]) => {
                this.showPackageDetails(packageIds)
            },

            onInitialized: (e: ISearchBySerialNbr) => {
                this.searchBySerialNbr = e
            },
        }
    }

    private showSearchBySerialNumber(): void {
        if (this.searchOptions != null) {
            this.searchBySerialNbr.show()
        }
    }

    private showPackageDetails(packageIds: number[]): void {
        this.systemService.openDetailsOrModule({
            moduleName: Enums.SimaxModuleName.Package,
            referenceObjectIds: packageIds
        })
    }

    // #endregion
}